"use strict";
/*
 * Created on 1. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../DomainObject");
/**
 * Sort definition for a field.
 * @author Radek Beran
 */


var SortDef =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SortDef, _DomainObject_1$Domai);

  /**
   * @param fieldName name of field to sort according
   * @param desc true if sorted in descendant order
   */
  function SortDef(fieldName, desc) {
    var _this;

    _classCallCheck(this, SortDef);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SortDef).call(this));
    _this.fieldName = fieldName;
    _this.desc = desc;
    return _this;
  }

  return SortDef;
}(DomainObject_1.DomainObject);

exports.SortDef = SortDef;